import React, { FC } from 'react';
import AIToolCard from './AIToolCard';
import styles from './AIToolList.module.scss';

interface ToolItem {
  /** 工具名称 */
  title: string;
  /** 工具描述 */
  description: string;
  /** 查看详情按钮文本 */
  linkText: string;
  /** 工具链接 */
  linkUrl: string;
  /** 是否外部链接 */
  linkOut?: boolean;
}

interface Props {
  /** 列表标题 */
  title: string;
  /** 工具列表数据 */
  tools: ToolItem[];
  /** 自定义类名 */
  className?: string;
}

/**
 * AI工具列表组件
 * 展示美团AI工具卡片列表
 */
const AIToolList: FC<Props> = (props) => {
  const { title, tools, className = '' } = props;

  return (
    <div className={`${styles['ai-tool-list-wrapper']} ${className}`}>
      <div className={styles['ai-tool-list-container']}>
        {/* AI工具标题 */}
        <h2 className={styles['ai-tool-list-title']}>{title}</h2>

        {/* AI工具卡片列表 */}
        <div className={styles['ai-tool-list-grid']}>
          {tools.map((tool, index) => (
            <AIToolCard
              key={index}
              title={tool.title}
              description={tool.description}
              linkText={tool.linkText}
              linkUrl={tool.linkUrl}
              linkOut={tool.linkOut}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

AIToolList.displayName = 'AIToolList';
export default AIToolList;
